<template>
    <div>
        <intalio-forms-render :ref="'RandomRef_' + dynamicFormRandomRef" settings="" :id="formId" :documentdata="documentData"/>
    </div>
</template>


<script>
    //import section started
    import constants from '@/assets/js/constants.js'
    import * as utils from '@/assets/js/common.js'
    import FormBuilderUtil from '@/utils/formBuilderHelper'

    // settings section started
    export default {
        name: 'DynamicFormRender',
        data() {
            return {
                dynamicFormDetails: [],
                form: FormBuilderUtil,
                utils: utils,
                localData: null,
                dynamicFormRandomRef: (Math.floor(Math.random() * 100) + 1).toString(),
            }
        },
        props: {
            //this will be the #id of the selector so please if you gona make it multiple in same page make sure its unique
            formId: { type: String, default: 'renderFormId' },
            //this is the filters allowing you to send the template name or id, structureId or even filter by categoryId
            filters: { type: Object, default: () => ({}) },
            //handle Document Data
            documentData: null
        },
        beforeMount() {
        },
        mounted() {
        },
        watch: {
            filters: {
                handler(newVal, oldVal) {
                    this.generateHtmlForForm();
                },
                deep: true // Enable deep watching
            }
        },
        methods: {
            generateHtmlForForm() {
                var formDetails = [
                    this.filters
                ]
                this.form = new FormBuilderUtil(formDetails);
                this.form.initializeFormio();

                var formRender = document.getElementById(this.formId);
                if (formRender)
                    formRender.setAttribute("settings", JSON.stringify(this.filters));
                else {
                    setTimeout(() => {
                        this.generateHtmlForForm();
                    }, 100);
                }
            }
        }
    }
</script>
<style>
    .alert-success {
        display: none;
    }
</style>